import { IStoreMetadata } from '@/data';
import { aspectRatioToPaddingTop } from './utils';

export function getCSSVariablesProductCard(data: IStoreMetadata): string {
  const { productCard } = data;

  if (!productCard) return '';

  const paddingTop = aspectRatioToPaddingTop(
    productCard?.product_image_aspect_ratio,
  );

  const mixBlendMode = productCard?.remove_bg_from_image
    ? 'multiply'
    : undefined;

  const cssVars: Record<string, string | undefined | null> = {
    '--product-card-img-aspect-ratio': paddingTop,
    '--product-card-img-object-fit':
      productCard.product_image_style || 'contain',
    '--product-card-img-mix-blend-mode': mixBlendMode,
  };

  return Object.entries(cssVars)
    .filter(([, value]) => typeof value === 'string')
    .map(([key, value]) => `${key}: ${value};`)
    .join(' ');
}
